
import Vue from "vue";

export default Vue.extend({
  name: "dialog-success",
  props: {
    isOpen: {
      type: Boolean,
    }
  },
  methods: {
    goToApp() {
      window.open("badesaba://calendar", "_self");
    },
    handelGoBab() {
      this.$store.commit("showLoading", true);
      //set true url for bab
      window.open("babonnaeim://doa?matnId=852&index=0", "_self");

      setTimeout(() => {
        this.$store.commit("showLoading", false);
        window.open("https://app.badesaba.ir/babon-naeim-info/", "_self");
      }, 5000);
    },
  },
});
